import { NavLink } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { NAV, type NavItem } from '../nav.js';
import { getMe, isAdmin } from '../lib/api.js';

const GROUPS: NavItem['group'][] = ['Sourcing', 'Portfolio', 'Tools'];

export function Sidebar({ open = false, onClose }: { open?: boolean; onClose?: () => void }) {
  // Same cached /me query the pages use, so this costs nothing extra. Until it resolves, admin-only
  // links stay hidden — better to reveal one a moment late than to flash it at everyone.
  const { data: meData } = useQuery({ queryKey: ['me'], queryFn: getMe, retry: false, staleTime: 300_000 });
  const items = NAV.filter((n) => !n.adminOnly || isAdmin(meData?.identity));

  return (
    <>
      {/* Mobile backdrop */}
      {open && <div className="fixed inset-0 bg-navy/40 z-40 md:hidden" onClick={onClose} aria-hidden />}
      <aside
        className={`w-[216px] flex-none h-screen bg-navy text-[#cdd8ea] flex flex-col z-50 md:z-auto
          fixed md:sticky top-0 left-0 transition-transform duration-200 md:translate-x-0
          ${open ? 'translate-x-0' : '-translate-x-full md:translate-x-0'}`}
      >
      <div className="flex items-center gap-2.5 px-[18px] pt-[18px] pb-3.5">
        <div className="w-[34px] h-[34px] rounded-[9px] bg-gradient-to-br from-teal to-teal-d flex items-center justify-center text-white font-extrabold text-[15px]">
          K
        </div>
        <div>
          <div className="font-bold text-white text-sm">Krit Capital</div>
          <div className="text-[9.5px] text-[#7f92b3] tracking-[1.5px] uppercase">Deal Engine</div>
        </div>
      </div>

      <nav className="px-2.5 py-1.5 flex flex-col gap-0.5 overflow-y-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {GROUPS.map((group) => (
          <div key={group}>
            <div className="text-[9.5px] tracking-[1.4px] text-[#61789f] uppercase px-2.5 pt-[11px] pb-1 font-bold">
              {group}
            </div>
            {items.filter((n) => n.group === group).map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === '/deals'}
                className={({ isActive }) =>
                  `flex items-center gap-[11px] px-3 py-[9px] rounded-lg text-[13px] font-medium ${
                    isActive
                      ? 'bg-teal/[0.16] text-white'
                      : 'text-[#cdd8ea] hover:bg-white/[0.06] hover:text-white'
                  }`
                }
              >
                <span className="w-[18px] text-center text-sm opacity-90">{n.icon}</span>
                {n.label}
              </NavLink>
            ))}
          </div>
        ))}
      </nav>

      <div className="mt-auto px-4 py-3 border-t border-white/[0.08] text-[10.5px] text-[#7f92b3]">
        <b className="text-[#cdd8ea] font-semibold">Krit Fund I</b>
        <br />
        SEBI Cat II AIF · Target ₹150 Cr
        <br />
        Mumbai · Abu Dhabi · KL
      </div>
      </aside>
    </>
  );
}
